import React, { Component } from 'react';

import { format } from 'date-fns';
import brLocale from "date-fns/locale/pt-BR";

import Grid from '@material-ui/core/Grid';

import Filters from '../../components/Filters/Filters';
import Text from '../../components/Inputs/Text/Text';
import SelectOption from '../../components/Inputs/Select/Select';
import { DatePicker } from '../../components/Inputs/DatePicker/DatePicker';

import EnumService from '../../services/Enum';

import { parseDate, toDate } from '../../helper/DateHelper';

import { removePagingAndSorting } from '../../helper/PaginationHelper';

export class EmailFilter extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            filters: {
                code: '',
                name: '',
                email: '',
                type: '',
                dataEnvio: '',
            },
            count: 0,
            optionsTypeMail: [],
        }
    }  

    // INPUTS
    handleChange = e => {
        this.setState({
            filters: {...this.state.filters, [e.target.name]: e.target.value }
        });
    };

    // INPUTS DATE PICKER
    handleChangeDate = (e, name, key) => {
        this.setState({
            filters: {...this.state.filters, [name]: e }
        });
    }

    // APLICAR PERSISTENCIA
    handleFilterPersistence = (filters) => {
        filters = removePagingAndSorting(filters);

        this.setState({
            filters: {
                code: filters.find(f =>  f.field === 'codigo') ? filters.find(f =>  f.field === 'codigo').value : "",
                name: filters.find(f =>  f.field === 'nome') ? filters.find(f =>  f.field === 'nome').value : "",
                email: filters.find(f =>  f.field === 'email') ? filters.find(f =>  f.field === 'email').value : "",
                type: filters.find(f =>  f.field === 'tipo') ? filters.find(f =>  f.field === 'tipo').value : "",
                dataEnvio: filters.find(f =>  f.field === 'dataEnvio') ? parseDate(filters.find(f =>  f.field === 'dataEnvio').value) : "",
            },
            count: filters.reduce((total, f) => f.value !== '' ? total + 1 : total, 0),
        })
    }

    // FILTROS
    handleFilterApply = () => {
        let f = [];
        const { filters } = this.state;

        if (filters.code) f.push({ field: 'codigo', value: filters.code });
        if (filters.name) f.push({ field: 'nome', value: filters.name });
        if (filters.email) f.push({ field: 'email', value: filters.email });
        if (filters.type) f.push({ field: 'tipo', value: filters.type });
        if (filters.dataEnvio) f.push({ field: 'dataEnvio', value: toDate(filters.dataEnvio) });

        this.props.handleFilterChange(f);
    }

    // LIMPAR FILTROS
    handleFilterClear = () => {
        this.setState({
            filters: {
                code: '',
                name: '',
                email: '',
                type: '',
                dataEnvio: '',
            },
            count: 0,
        })
        this.props.handleFilterChange([], false);
    }

    // CONTAGEM DE FILTROS ATIVOS
    handleCountFilters = () => this.state.count;

    async componentDidMount() {
        const tiposEmail = await EnumService.listarTiposEmail().then(res => res.data);
        this.setState({ optionsTypeMail: [...tiposEmail], });
    }

    render () {
        return (
            <Filters
                handleFilter={this.handleFilterApply}
                handleFilterClear={this.handleFilterClear}
                countFilters={this.handleCountFilters}
            >
                <Grid item container spacing={3}>
                    <Grid item sm={12} lg={2}>
                        <Text
                            label='Código do Candidato'
                            value={this.state.filters.code}
                            name='code'
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item sm={12} lg={3}>
                        <Text
                            label='Nome do Candidato'
                            value={this.state.filters.name}
                            name='name'
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item sm={12} lg={4}>
                        <Text
                            label='Email que Recebeu'
                            value={this.state.filters.email}
                            name='email'
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item sm={12} lg={3}>
                        <SelectOption
                            label="Tipo de Email"
                            name='type'
                            value={this.state.filters.type}
                            onChange={this.handleChange}
                            options={this.state.optionsTypeMail}
                        />
                    </Grid>
                </Grid>
                <Grid item container spacing={3}>
                    <Grid item sm={12} lg={2}>
                        <DatePicker
                            required
                            disableFuture
                            maxDate={format(new Date().setYear(new Date().getYear()), 'MM/dd/yy', { locale: brLocale })}
                            minDate={format(new Date().setYear(1920), 'MM/dd/yyyy', { locale: brLocale })}
                            label="Data de Envio"
                            name='dataEnvio'
                            value={this.state.filters.dataEnvio}
                            onChange={(e) => this.handleChangeDate(e, 'dataEnvio')}
                        />
                    </Grid>
                </Grid>
            </Filters>
        )
    }
}

export default EmailFilter;